import React, { useEffect, useState, useRef } from 'react';
import moment from 'moment';
import EchartLine from './TrendsEacherLine';
import { mathFormat } from '@/pages/intelligence/utils/commonUtils';
import { severalMathFormat } from '@/pages/intelligence/utils/echartsUtils';

const colorShiBar = ['#5086F3', '#5EC8F1'];
const colorTouBar = ['#5086F3', '#5EC8F1'];
const GameList = ['mobile', 'pc', 'console'];

const toFixed0 = (value, point = 2) => {
  let _newVal: string | number = parseFloat(value);
  if (value == '' || isNaN(_newVal)) {
    return '-';
  }
  _newVal = _newVal.toFixed(point);
  return _newVal + '%';
};

const GAME_TYPE: { [key: string]: any } = {
  mobile: 'Mobile',
  pc: 'PC',
  console: 'Console',
};
export default function MiddleEchart(props: any) {
  const {
    data,
    height,
    cardType = '',
    legendRender,
    maxWindow,
    defaultMinPoin = 0 /**revenue是0 player是1 */,
    windowHeight,
    windowWidth,
  } = props;

  const [seriesData, setSeriesData] = useState<any[]>([]);
  const [xLabel, setXLabel] = useState<any[]>([]);
  const [lineData, setLineData] = useState({});
  const currentYear = moment().format('YYYY');
  const lineRef = useRef(null);
  const genreXlabelWidth = 1560;

  // 计算每个类别下的数据组合
  const dataFormatter = (list: any[]) => {
    let _source = list?.length ? JSON.parse(JSON.stringify(list)) : [];
    let _lineData: any[] = [];
    let _xLabel: any[] = [];
    let _metrics: any[] = []; //获取后端返回所有指标名称-图例显示名称（除折线外）
    // let _total: any = [];

    // 获取所有的指标
    let metricSource = _source
      ?.map((v) => v?.metrics)
      ?.flat()
      ?.map((item) => item?.metric);
    _metrics = [...new Set(metricSource)]?.filter((v) => v != undefined);

    // 获取柱条每个series的数据，除total外
    let needList = _metrics?.map((item, index: number) => {
      let vData: any[] = [];
      _source?.forEach((v: any) => {
        vData?.push({
          value:
            v?.metrics?.find((_v: any) => _v?.metric === item)?.total || null,
          itemStyle: {
            // 今年及之后的柱状图存在透明度
            color:
              cardType === 'ByGenre'
                ? colorShiBar[index]
                : v?.date >= currentYear
                ? colorTouBar[index]
                : colorShiBar[index],
            borderWidth: 0.5, //堆叠柱状图色块之间存在白色间距设置
            borderColor: '#fff',
          },
          metric: item,
          region: v?.region_en,
        });
        // 仅遍历第一次时处理，获取折线数据及x轴label
        if (index === 0) {
          _lineData?.push(v?.total_dod);
          if (cardType === 'ByGenre') {
            _xLabel?.push(
              document.body.clientWidth > genreXlabelWidth
                ? v?.region_en
                : v?.region,
            );
          } else {
            _xLabel?.push(v?.date);
          }
          setXLabel(_xLabel);
        }
      });
      return {
        type: item,
        data: vData,
      };
    });
    if (cardType != 'ByGenre') {
      setLineData({
        name: 'YoY',
        data: _lineData,
        color: '#ED9142',
      });
    }

    return needList;
  };

  // 获取series中total数据，用于展示顶部数值，该series隐藏
  const reComputeTotal = (params?: any) => {
    const { selected } = params || {};
    let source = data?.length ? JSON.parse(JSON.stringify(data)) : [];
    let totalValList: any = [];
    source?.forEach((v) => {
      let totalList = params
        ? v?.metrics?.filter((_v) => selected[_v?.metric] === true)
        : v?.metrics;
      let totalVal = totalList?.reduce((pre, cur) => {
        return pre + Number(cur?.total);
      }, 0);

      totalValList?.push({
        value: totalVal,
        // flag: true,
        itemStyle: {
          color: 'rgba(128, 128, 128, 0)',
        },
      });
    });
    return {
      data: totalValList,
      flag: true, //用于判断该数据为total系列，需额外添加样式（颜色透明，显示顶部数值）
    };
  };

  /**
   * 格式处理seriesdata传入echartline组件
   * @param list serie中除total外s数据
   * @param top series中total数值
   * @param point 顶部数据保留几位小数，以及用于判断显示字体显示大小
   */
  const serieDataFormatter = (
    list: any[],
    top: any,
    point: any = defaultMinPoin,
  ) => {
    if (!list?.length) return;
    // 处理数据
    let obj: any = [];
    let _list = top ? [...list, top] : [...list];
    _list?.forEach((e: { type: any; data: any; flag?: boolean }, key: any) => {
      let item: { [key: string]: any } = {
        name: e.type,
        type: 'bar',
        stack: 'total',
        barCategoryGap: '50%',
        data: e.data,
        z: key === _list.length - 1 ? 4 : 3,
      };
      if (e?.flag) {
        // 总计柱条
        item.barGap = '-100%';
        item.stack = '';
        item.label = {
          show: true,
          position: 'top',
          valueAnimation: true,
          color: '#444',
          fontSize: point === defaultMinPoin ? 10 : 12,
          formatter: (params: any) => {
            return mathFormat(params?.value) === '-'
              ? ''
              : severalMathFormat(params?.value, true, 2);
          },
        };
      }
      obj.push(item);
    });
    setSeriesData(obj);
  };

  // 点击监听legend重新出现seriesdata数据传入echartline组件
  const getSelectedLegend = (params: any, width: any) => {
    let point = defaultMinPoin;
    if (width >= 400) {
      point = 2;
    }

    serieDataFormatter(
      dataFormatter(props?.data),
      reComputeTotal(params),
      point,
    );
  };

  const tooltipFun = (params: any) => {
    let list = params
      ?.sort((a, b) => b?.value - a?.value)
      ?.filter((v) => !v?.seriesName?.includes('series'));
    let leftTitle =
      list[0]?.axisValueLabel >= currentYear
        ? list[0]?.axisValueLabel
        : list[0]?.axisValueLabel;
    let leftTitleGener = list[0]?.data?.region;
    let rightTitle = '';
    let isShowMarket = true;

    let allContent = '';
    let contentArr = [];
    let returnStr = `
    <div class="dbi-chart-bubble-title">
      <div class="bubble-title-flex">
        <div class="bubble-title-flex-text">
          ${cardType == 'ByGenre' ? leftTitleGener : leftTitle}
        </div>
      </div>`;
    returnStr += rightTitle ? `<div class="bubble-title-flex-text">${rightTitle}</div>` : '';
    returnStr += `</div>`;
    for (let i = 0; i < list?.length; i++) {
      let nameVal = list[i]?.seriesName || '';
      let value = '';
      if (GameList?.includes(list[i]?.seriesName)) {
        nameVal = GAME_TYPE[list[i]?.seriesName];
      }

      if (list[i]?.seriesName === 'YoY') {
        value = toFixed0(list[i].value * 100);
      } else {
        value = mathFormat(list[i].value);
      }

      let item = {
        market: `<span class="bubble-lf-round" style="background-color:${list[i].color};"></span>`,
        name: `<span class="bubble-lf-name">${nameVal}</span>`,
        value: `<span>${value}</span>`,
      };
      contentArr?.push(item);
    }

    const getLine = contentArr?.map((v) => {
      return ` <div class="dbi-chart-bubble-item">
        <div class="dbi-chart-bubble-lf">${isShowMarket ? v?.market : ''} ${ v?.name}</div>
        <div class="dbi-chart-bubble-rt">${v?.value}</div>
      </div>`;
    });

    let bodyContent = `${getLine?.join('')}`;
    allContent = `<div class="dbi-chart-bubble" >${returnStr} ${bodyContent}</div>`;
    return allContent;
  };

  useEffect(() => {
    let point = defaultMinPoin;
    if (lineRef?.current?.clientWidth >= 400) {
      point = 2;
    }
    serieDataFormatter(dataFormatter(props?.data), reComputeTotal(), point);
  }, [data, maxWindow, document.body.clientWidth > genreXlabelWidth, height]);

  return (
    <div ref={lineRef}>
      <EchartLine
        windowHeight={windowHeight}
        windowWidth={windowWidth}
        height={height ? height - 120 : null}
        SummaryList={{
          list: seriesData, //该字段-组件内不在使用
          date: xLabel,
          summaryLine: lineData, //折线系列数据
          color: colorShiBar,
        }}
        getSelectedLegend={getSelectedLegend}
        list={seriesData} //柱条系列数据
        tooltipFormatter={tooltipFun}
        legendRender={legendRender}
      />
    </div>
  );
}
